import { gql } from '@apollo/client';
import { ErrorMessageInfo } from '@retainerclub/shared-api';
import { DiscountInfo } from '../fragments';

export default gql`
  mutation updateDiscount($input: DiscountUpdateInput!) {
    updateDiscount(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      discount {
        ...DiscountInfo
      }
    }
  }
  ${DiscountInfo}
  ${ErrorMessageInfo}
`;
